import { render, staticRenderFns } from "./MainProfile.vue?vue&type=template&id=034bcd74&scoped=true"
import script from "./MainProfile.vue?vue&type=script&lang=js"
export * from "./MainProfile.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "034bcd74",
  null
  
)

export default component.exports